import { funnelSteps } from '../../../mocks/funnel';

interface FunnelVisualProps {
  compareMode: boolean;
}

export default function FunnelVisual({ compareMode }: FunnelVisualProps) {
  const maxUsers = funnelSteps[0].users;

  return (
    <div className="bg-white rounded-2xl shadow-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-[16px] font-semibold text-charcoal-600">Dönüşüm Hunisi</h3>
          <p className="text-[12px] text-charcoal-300 mt-0.5">Her adımdaki kullanıcı sayısı ve dönüşüm oranları</p>
        </div>
        {compareMode && (
          <div className="flex items-center gap-4 text-[12px]">
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-champagne-500 inline-block" />Bu Dönem</span>
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-charcoal-200 inline-block" />Önceki Dönem</span>
          </div>
        )}
      </div>

      {/* Horizontal Funnel */}
      <div className="flex items-end gap-0 mb-6 overflow-x-auto pb-2">
        {funnelSteps.map((step, idx) => {
          const widthPct = (step.users / maxUsers) * 100;
          const barHeight = Math.max(48, (step.users / maxUsers) * 160);
          const isLast = idx === funnelSteps.length - 1;

          return (
            <div key={step.id} className="flex items-end group" style={{ flex: 1, minWidth: 90 }}>
              <div className="flex flex-col items-center w-full">
                {/* Label at top */}
                <div className="text-center mb-2 px-1">
                  <p className="text-[10px] font-semibold text-charcoal-500 leading-tight">{step.label}</p>
                </div>

                {/* Bar */}
                <div className="relative w-full flex flex-col items-center">
                  <div
                    className="w-full rounded-t-lg transition-all duration-500 cursor-pointer relative overflow-hidden"
                    style={{
                      height: barHeight,
                      backgroundColor: step.color,
                      opacity: 0.85,
                    }}
                    title={`${step.users.toLocaleString()} kullanıcı`}
                  >
                    <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                  {!isLast && (
                    <div className="absolute right-0 top-0 h-full w-3 flex items-center justify-center z-10">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-s-line text-charcoal-300 text-[14px]" />
                      </div>
                    </div>
                  )}
                </div>

                {/* Stats */}
                <div className="text-center mt-2 px-1">
                  <p className="text-[13px] font-bold text-charcoal-600">{step.users.toLocaleString()}</p>
                  <p className="text-[11px] text-champagne-600 font-medium">{step.conversionRate}%</p>
                  {idx > 0 && (
                    <p className="text-[10px] text-red-400 font-medium">-{step.dropOff}%</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Step Icons Row */}
      <div className="flex gap-0 overflow-x-auto">
        {funnelSteps.map((step, idx) => (
          <div key={step.id} className="flex items-center" style={{ flex: 1, minWidth: 90 }}>
            <div className="flex flex-col items-center w-full">
              <div className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: `${step.color}20` }}>
                <i className={`${step.icon} text-[14px]`} style={{ color: step.color }} />
              </div>
            </div>
            {idx < funnelSteps.length - 1 && (
              <div className="flex-shrink-0 w-4 h-px bg-border" />
            )}
          </div>
        ))}
      </div>

      {/* Summary Stats */}
      <div className="mt-6 grid grid-cols-4 gap-4 pt-5 border-t border-border">
        <div className="text-center">
          <p className="text-[11px] text-charcoal-300 mb-1">Toplam Giriş</p>
          <p className="text-[20px] font-bold text-charcoal-600">{maxUsers.toLocaleString()}</p>
        </div>
        <div className="text-center">
          <p className="text-[11px] text-charcoal-300 mb-1">WhatsApp Tıklama</p>
          <p className="text-[20px] font-bold text-charcoal-600">{funnelSteps[4].users.toLocaleString()}</p>
        </div>
        <div className="text-center">
          <p className="text-[11px] text-charcoal-300 mb-1">Form Gönderimi</p>
          <p className="text-[20px] font-bold text-charcoal-600">{funnelSteps[6].users.toLocaleString()}</p>
        </div>
        <div className="text-center">
          <p className="text-[11px] text-charcoal-300 mb-1">Genel Dönüşüm</p>
          <p className="text-[20px] font-bold text-champagne-600">{funnelSteps[7].conversionRate}%</p>
        </div>
      </div>
    </div>
  );
}
